import { DeliveryMethods } from '~/api/ETA';
import { WarehouseDeliveryMethods } from '~/api/ETA/v3/ETA';

export const getPrioritizedDeliveryMethod = (
  deliveryMethods: WarehouseDeliveryMethods,
): DeliveryMethods | undefined =>
  Object.values(deliveryMethods)
    .sort((a, b) => {
      const aMechanicPriority = Math.min(
        ...Object.values(a.deliveryMechanics).map((item) => item.priority),
      );
      const bMechanicPriority = Math.min(
        ...Object.values(b.deliveryMechanics).map((item) => item.priority),
      );
      return (
        (isNaN(aMechanicPriority) ? 0 : aMechanicPriority) -
        (isNaN(bMechanicPriority) ? 0 : bMechanicPriority)
      );
    })
    .map((item) => item.code as DeliveryMethods)
    .at(0);
